import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  wrapper: {
    '&:hover': {
      cursor: 'pointer'
    }
  },
  title: {
    margin: '0 0 8px'
  },
  prices: {
    fontSize: '13px',
    lineHeight: '18px',
    margin: '0 0 13px',
    fontWeight: 'bold'
  },
  detailsItem: {
    display: 'flex',
    margin: '0 0 12px'
  },
  detailsInfo: {
    fontSize: '13px',
    lineHeight: '18px',
    margin: '0 0 0 12px'
  },
  detailsIcon: {
    fontSize: '20px'
  },
  titleBlock: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    cursor: 'pointer'
  },
  arrowRightIcon: {
    fontSize: '11px',
    marginLeft: '10px'
  },
  currency: {
    color: theme.baseUI.color,
    fontWeight: 'bold'
  },
  pricePerDayWrapper: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  pricePerDayTitle: {
    display: 'inline-block'
  },
  photo: {
    width: '100%',
    height: '148px',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundColor: '#E2F5F8',
    marginBottom: '15px',
    ['@media (max-width:735px)']: {
      height: '180px'
    }
  },
  infoWrapper: {
    padding: '0 15px'
  }
}));

export default useStyles;
